import React from 'react';
import {Link, Navigate, useParams} from 'react-router-dom';
import ProductSettingsTab from './ProductSettingsTab';
import AddOnProductSettingsTab from './AddOnProductSettingsTab';
import ProductGroupSettingsTab from './ProductGroupSettingsTab';
import CustomerSettingsTab from './CustomerSettingsTab';
import OrderSettingsTab from "./OrderSettingsTab";
import StorefrontSettingsTab from "./StorefrontSettingsTab";
import InvoiceSettingsTab from "./InvoiceSettingsTab";
import PaymentSettingsTab from "./PaymentSettingsTab";

const TABS = [
    {slug: 'product-settings', label: 'Product Settings', icon: 'mdi-account', Component: ProductSettingsTab},
    {slug: 'add-on-product-settings', label: 'Add On Product Settings', icon: 'mdi-office-building', Component: AddOnProductSettingsTab},
    {slug: 'product-group-settings', label: 'Product Group Settings', icon: 'mdi-account-group', Component: ProductGroupSettingsTab},
    {slug: 'customer-settings', label: 'Customer Settings', icon: 'mdi-account-group', Component: CustomerSettingsTab},
    {slug: 'order-settings', label: 'Order Settings', icon: 'mdi-account-group', Component: OrderSettingsTab},
    {slug: 'storefront-settings', label: 'Storefront Settings', icon: 'mdi-store', Component: StorefrontSettingsTab},
    {slug: 'invoice-settings', label: 'Invoice Settings', icon: 'mdi-file-document', Component: InvoiceSettingsTab},
    {slug: 'payment-settings', label: 'Payment Settings', icon: 'mdi-credit-card', Component: PaymentSettingsTab},
];

function SettingsPage() {
    const {tab} = useParams();
    const active = TABS.find((t) => t.slug === tab);
    if (!active) {
        return <Navigate to={`/settings/${TABS[0].slug}`} replace />;
    }
    const ActiveComponent = active.Component;

    return (
        <>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card-box">
                        <ul className="nav nav-tabs nav-bordered">
                            {TABS.map((t) => (
                                <li className="nav-item" key={t.slug}>
                                    <Link to={`/settings/${t.slug}`}
                                          className={`nav-link ${active.slug === t.slug ? 'active' : ''}`}>
                                        <span className="d-inline-block d-sm-none"><i className={`mdi ${t.icon}`}/></span>
                                        <span className="d-none d-sm-inline-block">{t.label}</span>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                        <div className="tab-content">
                            <ActiveComponent />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SettingsPage;
